import { useFormContext, useWatch } from "react-hook-form";
import type { ChannelName } from "../../../../channels/types";
import type { MomentFormMoment } from "../../../types/moment-form-moment";

export function useSelectedChannel(): ChannelName {
  const { control, getValues } = useFormContext<MomentFormMoment>();
  useWatch({ control, name: "channel" });
  return getValues("channel");
}
